import React, { useState } from 'react';
import { bool, func, instanceOf, number, shape } from 'prop-types';
import { isEqual } from 'lodash';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Modal } from 'antd';

import UserFeedback from 'Src/common/components/UserFeedback';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import '../style.scss';

function RatingModal({ isOpen, closeRatingModal, connection, submitRating }) {
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(null);

  const { mentor, mentee, status } = connection;
  const isMentor = window.userData.id === mentor?.id;
  const primaryData = isMentor ? mentee : mentor;
  const questions = isMentor ? window.mentorFeedbackQuestions : window.menteeFeedbackQuestions;

  const onFeedbackChange = (data) => {
    setFeedback(data);
  };

  const onRatingChange = (data) => {
    setRating(data);
  };

  const onSubmitRating = () => {
    submitRating({
      rating,
      comment: feedback,
      connection,
    });
  };

  return (
    <Modal
      width={400}
      closable={false}
      onCancel={closeRatingModal}
      wrapClassName="connection-rating-modal"
      visible={isOpen}
      title={
        <div className="arc-d-flex arc-flex-vertical-align">
          <Button onClick={closeRatingModal} className="mentorship-modal-left-arrow">
            <FontAwesomeIcon icon={faArrowLeft} onClick={closeRatingModal} />
          </Button>
          <h6 className="arc-H200 ml8">
            <I18nCustomFormatter id="feedback-label" />
          </h6>
        </div>
      }
      footer={
        <Button
          className="close-connection-button"
          size="large"
          type="primary"
          block
          disabled={!rating}
          onClick={onSubmitRating}>
          <I18nCustomFormatter id={isEqual(status, 5) ? 'submit-rating-button' : 'close-connection-button'} />
        </Button>
      }>
      <div className="arc-d-flex rating-modal-content">
        <Avatar shape="square" size={104} src={primaryData.present_picture} />
        <UserFeedback
          question={{
            main: questions[0].feedback_question,
            followUp: {
              positive: questions[0].reason_question_positive.question,
              negative: questions[0].reason_question_negative.question,
            },
          }}
          onRatingChange={onRatingChange}
          onFeedbackChange={onFeedbackChange}
          submitting={false}
          submittedFeedback={false}
          hasSubmitButton={false}
        />
      </div>
    </Modal>
  );
}

RatingModal.propTypes = {
  closeRatingModal: func.isRequired,
  connection: shape({
    mentee: instanceOf(Object).isRequired,
    mentor: instanceOf(Object).isRequired,
    status: number.isRequired,
  }).isRequired,
  isOpen: bool.isRequired,
  submitRating: func.isRequired,
};

export default RatingModal;
